export default __webpack_public_path__ + "static/media/edit_btn_icon.6a375c4a.svg";